import React, { Component } from 'react'
import Styles from '../sass/layout/Portfolio.module.sass'

const req = require.context('../images/portfolio',true);

class Portfolio extends Component {
  render(){
    var PortfolioData = this.props.PortfolioData;
    return(
      <div className={Styles.portfolio}>
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <h2 className={Styles.portfolioIntro}>Port</h2>
              <h2 className={Styles.portfolioIntro}>folio</h2>
            </div>
            {
              PortfolioData.PortfolioItems.map(items=> {
                return(
                  <div className="col-lg-4 mb-30" key={items.id}>
                    <div className={Styles.portfolioSingle}>
                      <div className={Styles.portfolioSingle__thumb}>
                        <img src={req(`./${items.imgUrl}.jpg`).default} alt="portfolio" />
                      </div>
                      <div className={Styles.portfolioSingle__content}>
                        <h4>{items.title}</h4>
                        <p>Client : <span className={Styles.client}>{items.client}</span></p>
                        <a href={items.link}>Live Demo</a>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  }
}


export default Portfolio